import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import Card from '../../../components/Card'
import { useGetForwarderMutation, useUpdateForwarderMutation } from '../../../api/forwardersAPISlices'
import { useNavigate, useParams } from 'react-router-dom'
import Toaster from '../../../components/utility/Toaster'

const ForwardersEdit = () => {
    const { forwarderId } = useParams();
    const [forwardingUrl, setForwardingUrl] = useState('');
    const [forwardUrl, setForwardUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(true);

    const [showToster, setShowToster] = useState(false);
    const [tosterMassage, setTosterMassage] = useState('');
    const [tosterStatus, setTosterStatus] = useState('');
    const [errors, setErrors] = useState({});

    const navigate = useNavigate();

    const authToken = JSON.parse(localStorage.getItem("token"));

    const [getForwarder] = useGetForwarderMutation();
    const [updateForwarder] = useUpdateForwarderMutation();

    useEffect(() => {
        fetchForwarderData();
    }, [forwarderId])

    const fetchForwarderData = async () => {
        setIsFetching(true);
        await getForwarder({ forwarderId, token: authToken })
            .unwrap()
            .then((res) => {
                setForwardingUrl(res.forwarding_url);
                setForwardUrl(res.forward_url);
                setIsFetching(false);
            })
            .catch((error) => {
                setShowToster(true)
                setTosterMassage(error?.data?.message || 'Error loading forwarder')
                setTosterStatus('error')
                setIsFetching(false);
            });
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        setShowToster(true)
        setTosterMassage('Forward URL copied to clipboard')
        setTosterStatus('success')
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true)

        const payload = {
            forwarding_url: forwardingUrl,
        };

        await updateForwarder({ payload, forwarderId, token: authToken })
            .unwrap()
            .then((res) => {
                setErrors({})
                setShowToster(true)
                setTosterMassage('Forwarder updated successfully')
                setTosterStatus('success')
                setIsLoading(false)
                setTimeout(() => {
                    navigate("/forwarders-list");
                }, 1500);
            })
            .catch((error) => {
                setShowToster(true)
                setTosterMassage(error?.data?.message || 'Error updating forwarder')
                setTosterStatus('error')
                setErrors(error?.data?.errors || {})

                setIsLoading(false)
            });
    };

    if (isFetching) {
        return (
            <Container fluid>
                <div className='text-center mt-5 pt-5'>
                    <div className="spinner-border text-warning mr-2" role="status">
                        <span className="visually-hidden"></span>
                    </div>
                </div>
            </Container>
        );
    }

    return (
        <>
            <Container fluid>
                <Row>
                    <Col lg="12" className='mb-5'>
                        <Card>
                            <Card.Header>
                                <Card.Header.Title>
                                    <h4 className="card-title">Edit Lead Forwarder</h4>
                                </Card.Header.Title>
                            </Card.Header>

                            <Card.Body>
                                <Form onSubmit={onSubmit}>
                                    <Row>
                                        <Form.Group controlId="forwarding_url" as={Col} sm="12" md="8">
                                            <Form.Label>Forwarding URL:</Form.Label>
                                            <Form.Control
                                                type="url"
                                                placeholder="https://example.com/webhook"
                                                required
                                                value={forwardingUrl}
                                                onChange={(e) => setForwardingUrl(e.target.value)}
                                                isInvalid={errors?.forwarding_url && errors?.forwarding_url?.length > 0}
                                            />
                                            <Form.Text className="text-muted">
                                                Enter the URL where leads will be forwarded.
                                            </Form.Text>
                                            <Form.Control.Feedback type="invalid">
                                                {errors?.forwarding_url?.[0]}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group controlId="forward_url" as={Col} sm="12" md="8" className="mt-3">
                                            <Form.Label>Forward From URL:</Form.Label>
                                            <div className="d-flex align-items-center">
                                                <Form.Control
                                                    type="text"
                                                    value={forwardUrl}
                                                    readOnly
                                                    disabled
                                                />
                                                <Button
                                                    variant="outline-primary"
                                                    className="ml-2"
                                                    onClick={() => copyToClipboard(forwardUrl)}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                                    </svg>
                                                </Button>
                                            </div>
                                            <Form.Text className="text-muted">
                                                Use this URL to receive forwarded leads. This URL cannot be changed.
                                            </Form.Text>
                                        </Form.Group>
                                    </Row>

                                    <div className="mt-4">
                                        <Button type="submit" variant="primary" disabled={isLoading}>
                                            <div
                                                style={{
                                                    transform: !isLoading ? 'translateX(-1.2rem)' : 'translateX(0)'
                                                }}
                                            >
                                                <div className="spinner-border text-warning loadding-spinner mr-2"
                                                    style={{
                                                        opacity: isLoading ? 100 : 0,
                                                    }}
                                                    role="status"
                                                >
                                                    <span className="visually-hidden"></span>
                                                </div>

                                                <span>Update</span>
                                            </div>
                                        </Button>
                                        <Button
                                            variant="secondary"
                                            className="ml-2"
                                            onClick={() => navigate("/forwarders-list")}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <Toaster status={tosterStatus} message={tosterMassage} show={showToster} setShow={setShowToster} />
        </>
    )
}

export default ForwardersEdit
